import { createFileRoute, redirect } from '@tanstack/react-router';

// Contacts left the settings drawer to become a first-class primary tab. This
// pre-existing settings URL redirects to the canonical top-level Contacts list
// so old bookmarks keep working; nothing renders under settings anymore. The
// incoming search is carried through so the report Fix-Issues deep-link
// (returnTo/reportId) survives the redirect instead of being dropped.
export const Route = createFileRoute('/admin/finance/settings/contacts/')({
  beforeLoad: ({ search }: { search: Record<string, unknown> }) => {
    throw redirect({ to: '/admin/finance/contacts', search });
  },
});
